import React from 'react'
import team from "../../../images/students/team.webp"
import chat from "../../../images/students/chat.webp"
import certified from "../../../images/students/certified.webp"
import spoke from "../../../images/students/spoke.webp"


export default function TransformationModel() {
    return (
        <div className='mb-[20px] sm:mb-[50px] xl:mb-[70px] p-[20px] md:p-[40px] relative z-0 w-full overflow-hidden text-center bg-[#F9FAFB]'>
            <h3 className='text-[#101828] text-[20px] md:text-[36px] font-semibold'>1000 Student Transformation Model</h3>
            <div className='grid lg:grid-cols-2 gap-[17px] md:w-10/12 xl:w-10/12 mx-auto mt-[20px] md:mt-[40px]'>
                <div className='bg-[#FFFFFF] rounded-[14px] md:rounded-[20px] py-[16px] md:py-[22px]' style={{ boxShadow: "0px 0px 3px 0px #0000004A" }}>
                    <img src={team} alt='team' className='mx-auto size-[90px] md:size-[110px]' />
                    <p className='mt-[10px] text-[#000000] font-medium text-[16px] md:text-[22px]'>Hybrid activities (Workshops, Circles)</p>
                </div>
                 <div className='bg-[#FFFFFF] rounded-[14px] md:rounded-[20px] py-[16px] md:py-[22px]' style={{ boxShadow: "0px 0px 3px 0px #0000004A" }}>
                    <img src={chat} alt='chat' className='mx-auto size-[90px] md:size-[110px]' />
                    <p className='mt-[10px] text-[#000000] font-medium text-[16px] md:text-[22px]'>Star speakers on campus</p>
                </div>
                 <div className='bg-[#FFFFFF] rounded-[14px] md:rounded-[20px] py-[16px] md:py-[22px]' style={{ boxShadow: "0px 0px 3px 0px #0000004A" }}>
                    <img src={certified} alt='certified' className='mx-auto size-[90px] md:size-[110px]' />
                    <p className='mt-[10px] text-[#000000] font-medium text-[16px] md:text-[22px]'>Frame-worthy Surge certificate</p>
                </div>
                 <div className='bg-[#FFFFFF] rounded-[14px] md:rounded-[20px] py-[16px] md:py-[22px]' style={{ boxShadow: "0px 0px 3px 0px #0000004A" }}>
                    <img src={spoke} alt='spoke' className='mx-auto size-[90px] md:size-[110px]' />
                    <p className='mt-[10px] text-[#000000] font-medium text-[16px] md:text-[22px]'>Surge celebration day</p>
                </div>
                
            </div>
            <div className='mt-[20px] md:mt-[40px] gap-[16px] flex flex-wrap justify-center items-center'>
                <button className='w-full md:w-[360px] h-[40px] md:h-[60px] rounded-[14px] bg-[#34C759] text-[#FFFFFF] text-[14px] md:text-[18px] font-semibold'>Partner With Us</button>
                <button className='w-full md:w-[360px] h-[40px] md:h-[60px] rounded-[14px] border-[#C6C6C8] border text-[#000000] text-[14px] md:text-[18px] font-semibold'>Book a Meeting</button>
            </div>
        </div>
    )
}
